<section class="container-fluid sts-section sts-form account-username-display"
         [ngClass]="{'usernameShown': !!username}" tabindex="0">

  <app-sts-section-header *ngIf="!username && !isChanged" key="sts-forgot-username-header" [errors]="errors">
    Provide key identifiers
    <app-sts-section-header-side>
      <div class="text-right"><a
        routerLink="/account/help" app-sts-cms-txt key="sts-need-help">Need help?</a>
      </div>
    </app-sts-section-header-side>
  </app-sts-section-header>

  <app-sts-section-header *ngIf="!!username && !isChanged" key="sts-forgot-username-header-success" [errors]="errors">
    User ID
    <app-sts-section-header-side>
      <div class="text-right"><a
        routerLink="/account/help" app-sts-cms-txt key="sts-need-help">Need help?</a>
      </div>
    </app-sts-section-header-side>
  </app-sts-section-header>

  <app-sts-section-header *ngIf="!!username && isChanged" key="sts-changed-username-header-success" [errors]="errors">
    You have successfully changed your user ID.
    <app-sts-section-header-side>
      <div class="text-right"><a
        routerLink="/account/help" app-sts-cms-txt key="sts-need-help">Need help?</a>
      </div>
    </app-sts-section-header-side>
  </app-sts-section-header>

  <app-sts-section-body *ngIf="!username && !isChanged"
                        key="sts-forgot-username-body-section"
                        class="sts-signin-text">
    Please provide the following information to retrieve your username.
    Select <b>Next</b> when you are finished.
  </app-sts-section-body>

  <div class="form-section">
    <app-sts-self-identifiers [mode]="mode"
                              (onErrors)="showErrors($event)"
                              (onCancel)="gotoHome($event)"
                              (onSuccess)="onSuccess($event)"></app-sts-self-identifiers>
  </div>

  <div class="username-display-section row">
    <p class="spaced-bottom">
      <a routerLink="/account/reg-step-2/{{userId}}/true/false" app-sts-cms-txt key="sts-change-userid">Change User Id</a>
    </p>
  </div>

  <div class="username-display-section row">
    <p class="spaced-bottom">
      <strong app-sts-cms-txt key="sts-your-user-name-is">Your User ID is:</strong> {{username}}
    </p>
    <!-- -->
    <div class="sts-object">
      <button app-sts-cms-txt key="sts-return-to-login"
            class="sts-btn other-sts-btn"
            type="button"
            (click)="gotoHome($event)">
        Return to Login
      </button>
    </div>
    <!-- -->
  </div>

</section>


